import * as mapbox from 'mapbox-gl';
import { useEffect, useState, useRef } from 'react';

export const useMap = (ready: boolean, container: HTMLElement, center: mapbox.LngLatLike): [mapbox.Map, mapbox.LngLatBounds] => {
    const [map, setMap] = useState<mapbox.Map>();
    const bounds = useRef(new mapbox.LngLatBounds());

    useEffect(() => {
        if (container && ready) {
            const token = process.env.MIX_MAPBOX_TOKEN;

            (mapbox as any).accessToken = token;
            (mapbox as any).config.ACCESS_TOKEN = token;

            const m = new mapbox.Map({
                    container,
                    center,
                    zoom: 5,
                    // style: 'mapbox://styles/johncatt/cjtfp58jw04r71fo5a71i320x',
                    style: 'mapbox://styles/johncatt/cjxlom7js12q71cnwbtkclrnn',
                    attributionControl: false,
                    logoPosition: 'top-right',
                })
                .addControl(new mapbox.AttributionControl({
                    compact: true,
                }));

            setMap(m);
        }

        return () => {
            if (map) {
                map.remove();
            }
        };
    }, [container, ready]);

    return [map, bounds.current];
}
